<div class="row downloads-links">
  <div class="col-12 col-lg-6">
    <a href="https://llsdata.app.box.com/s/sg8710qtf8jsn13pgy0ulzf8sbj2la67" target="_blank">General Resources</a>
    <a href="https://llsdata.app.box.com/s/2lguo1d749l76dr1a3duj1rspgzt3fyn" target="_blank">Corporate Team Captain Toolkit</a>
  </div>
  <div class="col-12 col-lg-6">
    <a href="https://llsdata.app.box.com/s/hygc17f1mxg3tke0nmfjenfm96ky4izv" target="_blank">Friends and Family Team Captain Toolkit</a>
    <a href="https://llsdata.app.box.com/s/7iez96ytj6hw9j4ruhg7l0i8m9nmc171" target="_blank">Walker Toolkit</a>
  </div>
</div>